import React from 'react';
import HeroSection from '../../components/UserSideComponents/Home/HeroSection';
import AboutSnapshot from '../../components/UserSideComponents/Home/AboutSnapshot';
import ServicesOverview from '../../components/UserSideComponents/Home/ServicesOverview';
import FeaturedProjects from '../../components/UserSideComponents/Home/FeaturedProjects';
import TrustSection from '../../components/UserSideComponents/Home/TrustSection';
import ClientLogos from '../../components/UserSideComponents/Home/ClientLogos';

const Home = () => (
    <div className='overflow-hidden'>
        <HeroSection />
        <AboutSnapshot />
        <ServicesOverview />
        <FeaturedProjects />
        <TrustSection />
        <ClientLogos />
    </div>
);

export default Home;
